<template>
  <div>
    <div
      class="header w-full h-14 flex justify-between items-center mb-4 flex-wrap"
      style="height: 50px"
    >
      <div class="flex items-center justify-center">
        <div class="cursor-pointer">
          <inertia-link href="/">
            <img src="/goback.svg" alt="Voltar" />
          </inertia-link>
        </div>
        <div class="h-10 w-52">
          <inertia-link href="/">
            <img :src="'/logo-slim-dark.png'" alt="Logo" class="w-full h-full" />
          </inertia-link>
        </div>
      </div>
    </div>
    <div class="bg-white rounded-xl max-h-screen p-3 container desktop">
      <div class="flex flex-col gap-2">
        <img :src="`/modal.png`" class="w-10" />
        <h2 class="panel-title">Sistema preditivo de Modais</h2>
        <inertia-link
          :class="{ 'link-active': isMenuSelected('interactive-map') }"
          class="menu-link"
          @click="selectMenu('interactive-map')"
          :href="route('transport-modes.interactive-map')"
        >
          <div class="flex justify-start items-center gap-3 p-3 rounded-md">
            <i
              :class="[
                {
                  'fa-regular': !isMenuSelected('interactive-map'),
                  'fa-solid': isMenuSelected('interactive-map'),
                },
                'fa-map',
                { 'text-white': isMenuSelected('interactive-map') },
              ]"
            ></i>
            <div
              :class="
                isMenuSelected('interactive-map')
                  ? 'text-white'
                  : 'text-gray-600 group-hover:text-white'
              "
            >
              Mapa Preditivo
            </div>
          </div>
        </inertia-link>
        <inertia-link
          :class="{ 'link-active': isMenuSelected('economic-performance') }"
          class="menu-link"
          @click="selectMenu('economic-performance')"
          :href="route('transport-modes.economic-performance')"
        >
          <div class="flex justify-start items-center gap-3 p-3 rounded-md">
            <i
              :class="[
                {
                  'fa-regular': !isMenuSelected('economic-performance'),
                  'fa-solid': isMenuSelected('economic-performance'),
                },
                'fa-money-bill-1',
                { 'text-white': isMenuSelected('economic-performance') },
              ]"
            ></i>
            <div
              :class="
                isMenuSelected('economic-performance')
                  ? 'text-white'
                  : 'text-gray-600 group-hover:text-white'
              "
            >
              Desempenho Econômico
            </div>
          </div>
        </inertia-link>
        <inertia-link
          :class="{ 'link-active': isMenuSelected('profile') }"
          class="menu-link"
          @click="selectMenu('profile')"
          :href="route('transport-modes.profile')"
        >
          <div class="flex justify-start items-center gap-3 p-3 rounded-md">
            <i
              :class="[
                { 'fa-regular': !isMenuSelected('profile'), 'fa-solid': isMenuSelected('profile') },
                'fa-user',
                { 'text-white': isMenuSelected('profile') },
              ]"
            ></i>
            <div
              :class="
                isMenuSelected('profile') ? 'text-white' : 'text-gray-600 group-hover:text-white'
              "
            >
              Perfil do Visitante
            </div>
          </div>
        </inertia-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showMenu: false,
      selectedMenu: '',
    }
  },
  methods: {
    isUrl(url) {
      const current = this.$page.url.substr(1)

      if (url === '') {
        return current === ''
      }

      return current.startsWith(url)
    },
    hasPerm(perm) {
      return this.$page.props.auth.user.roles.includes(perm)
    },
    selectMenu(menuId) {
      this.selectedMenu = menuId
    },
    isMenuSelected(menuId) {
      return this.selectedMenu === menuId
    },
    setSelectedMenuBasedOnUrl() {
      const currentUrl = this.$page.url
      if (currentUrl.includes('economic-performance')) {
        this.selectedMenu = 'economic-performance'
      } else if (currentUrl.includes('profile')) {
        this.selectedMenu = 'profile'
      } else if (currentUrl.includes('interactive-map')) {
        this.selectedMenu = 'interactive-map'
      } else {
        this.selectedMenu = 'interactive-map'
      }
    },
  },
  mounted() {
    this.setSelectedMenuBasedOnUrl()
    document.addEventListener('click', this.handleGlobalClick)
  },
}
</script>

<style scoped>
.panel-title {
  text-align: left;
  line-height: 2rem;
}
.link-active {
  background-color: #64b4c8;
  border-radius: 8px;
  padding: 6px 0;
  transition:
    background-color 0.3s,
    color 0.3s;
}

.menu-link:hover {
  filter: brightness(1.5);
}
.container {
  height: calc(100vh - 120px);
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
}

.mobile {
  display: none;
}

.menu-mobile {
  position: absolute;
  top: 50px;
  background-color: #fff;
  width: 180px;
  height: max-content;
  z-index: 10;
  border-radius: 12px;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
  user-select: none;
}

.unselectable {
  user-select: none;
}
.text-white {
  color: white;
}
@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: block;
  }
}
</style>
